import "@/App.css";
import "leaflet/dist/leaflet.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { TachoProvider } from "@/context/TachoContext";
import { ThemeProvider, useTheme } from "@/context/ThemeContext";
import { LangProvider } from "@/context/LangContext";
import AppShell from "@/components/AppShell";
import Login from "@/pages/Login";
import Home from "@/pages/Home";
import TripDetail from "@/pages/TripDetail";
import Navigator from "@/pages/Navigator";
import Documents from "@/pages/Documents";
import Breaks from "@/pages/Breaks";

const Protected = () => {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen grid place-items-center text-slate-400">Caricamento…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return (
    <TachoProvider>
      <AppShell />
    </TachoProvider>
  );
};

const ThemedToaster = () => {
  const { theme } = useTheme();
  return <Toaster position="top-center" richColors theme={theme} />;
};

function App() {
  return (
    <ThemeProvider>
    <LangProvider>
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<Protected />}>
            <Route path="/" element={<Home />} />
            <Route path="/viaggio/:id" element={<TripDetail />} />
            <Route path="/navigatore" element={<Navigator />} />
            <Route path="/documenti" element={<Documents />} />
            <Route path="/pausa" element={<Breaks />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <ThemedToaster />
    </AuthProvider>
    </LangProvider>
    </ThemeProvider>
  );
}

export default App;
